import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import SlidingTab from '../../../../components/SlidingTab/SlidingTab';
import useDashboardStore from "../../../../stores/dashboard";
import Spinner from '../../../../components/Loaders/Spinner';
import { getTopChargebacks } from '../../../../../api';
import moment from 'moment';

// Function to format numbers with K, M, B suffixes
const formatNumber = (num) => {
  // if (num < 0) {
  //   return '-' + formatNumber(-num);
  // }
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
};

const TrendUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path d="M22.8334 5.25V11.25C22.8334 11.4489 22.7544 11.6397 22.6138 11.7803C22.4731 11.921 22.2823 12 22.0834 12C21.8845 12 21.6937 11.921 21.5531 11.7803C21.4124 11.6397 21.3334 11.4489 21.3334 11.25V7.06031L13.614 14.7806C13.5444 14.8504 13.4617 14.9057 13.3706 14.9434C13.2796 14.9812 13.182 15.0006 13.0834 15.0006C12.9849 15.0006 12.8873 14.9812 12.7962 14.9434C12.7052 14.9057 12.6225 14.8504 12.5528 14.7806L9.33342 11.5603L3.11405 17.7806C2.97332 17.9214 2.78245 18.0004 2.58342 18.0004C2.3844 18.0004 2.19353 17.9214 2.0528 17.7806C1.91207 17.6399 1.83301 17.449 1.83301 17.25C1.83301 17.051 1.91207 16.8601 2.0528 16.7194L8.8028 9.96937C8.87245 9.89964 8.95517 9.84432 9.04622 9.80658C9.13727 9.76884 9.23486 9.74941 9.33342 9.74941C9.43199 9.74941 9.52958 9.76884 9.62063 9.80658C9.71168 9.84432 9.7944 9.89964 9.86405 9.96937L13.0834 13.1897L20.2731 6H16.0834C15.8845 6 15.6937 5.92098 15.5531 5.78033C15.4124 5.63968 15.3334 5.44891 15.3334 5.25C15.3334 5.05109 15.4124 4.86032 15.5531 4.71967C15.6937 4.57902 15.8845 4.5 16.0834 4.5H22.0834C22.2823 4.5 22.4731 4.57902 22.6138 4.71967C22.7544 4.86032 22.8334 5.05109 22.8334 5.25Z" fill="#E03B24" />
    </svg>
  )
}

const TrendDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path d="M22.8334 12V18C22.8334 18.1989 22.7544 18.3897 22.6138 18.5303C22.4731 18.671 22.2823 18.75 22.0834 18.75H16.0834C15.8845 18.75 15.6937 18.671 15.5531 18.5303C15.4124 18.3897 15.3334 18.1989 15.3334 18C15.3334 17.8011 15.4124 17.6103 15.5531 17.4697C15.6937 17.329 15.8845 17.25 16.0834 17.25H20.2731L13.0834 10.0603L9.86405 13.2806C9.7944 13.3503 9.71168 13.4057 9.62063 13.4434C9.52958 13.4812 9.43199 13.5006 9.33342 13.5006C9.23486 13.5006 9.13727 13.4812 9.04622 13.4434C8.95517 13.4057 8.87245 13.3503 8.8028 13.2806L2.0528 6.53061C1.91207 6.38988 1.83301 6.19901 1.83301 5.99999C1.83301 5.80097 1.91207 5.6101 2.0528 5.46936C2.19353 5.32863 2.3844 5.24957 2.58342 5.24957C2.78245 5.24957 2.97332 5.32863 3.11405 5.46936L9.33342 11.6897L12.5528 8.46936C12.6225 8.39963 12.7052 8.34431 12.7962 8.30657C12.8873 8.26883 12.9849 8.2494 13.0834 8.2494C13.182 8.2494 13.2796 8.26883 13.3706 8.30657C13.4617 8.34431 13.5444 8.39963 13.614 8.46936L21.3334 16.1897V12C21.3334 11.8011 21.4124 11.6103 21.5531 11.4697C21.6937 11.329 21.8845 11.25 22.0834 11.25C22.2823 11.25 22.4731 11.329 22.6138 11.4697C22.7544 11.6103 22.8334 11.8011 22.8334 12Z" fill="#37B450" />
    </svg>
  )
}

const Chargebacks = () => {
  const [chargebacks, setChargebacks] = useState([]);
  const [loading, setLoading] = useState(true);

  const filterStartDate = useDashboardStore(state => state.filterData.startDate);
  const filterEndDate = useDashboardStore(state => state.filterData.endDate);
  const filterUser = useDashboardStore((s) => s.filterUser);
  const filterOrg = useDashboardStore((s) => s.filterOrg);

  useEffect(() => {
    getTopChargebacks({
      start_date: filterStartDate,
      end_date: filterEndDate,
      user_id: filterUser,
      org_id: filterOrg
    }).then(res => {
      if (res.status) {
        setChargebacks(res.data);
      }
    })
      .catch((err) => { })
      .finally(() => {
        setLoading(false);
      });
  }, [filterStartDate, filterEndDate, filterUser, filterOrg]);


  return (
    <div className={styles.activeMerchant} >
      <div className={styles.activeMerchantHeader} >
        <div className={styles.activeMerchantHeaderContent} >
          <p className={styles.activeMerchantHeaderTitle} >Chargebacks</p>
          <p className={styles.activeMerchantHeaderDate} >{moment(filterStartDate).format('DD MMM YYYY')} - {moment(filterEndDate).format('DD MMM YYYY')}</p>
        </div>
      </div>

      {loading && (
        <div className={styles.activeMerchantLoading} >
          <Spinner />
        </div>
      )}

      {!loading && (
        <>
          {chargebacks?.length > 0 ? (
            <div className={styles.activeMerchantList} >
              {chargebacks.map((chargeback, index) => (
                <div key={index} className={styles.activeMerchantListItem} >
                  <div className={styles.activeMerchantListItemContent} >
                    <p className={styles.activeMerchantListItemTitle} >{chargeback.dba_name}</p>
                    <p className={styles.activeMerchantListItemDescription} >
                      {index <= 1 && "Suspicious"}
                      {index == 2 && "Pay Attention"}
                      {index > 2 && "Normal"}
                    </p>
                  </div>

                  <div className={styles.amountContainer} >
                    <p className={`${styles.amountValue} ${index <= 2 ? styles.colorWarning : ''}`} >$ {formatNumber(+chargeback.total_chargeback_amount)}</p>
                  </div>

                  <div className={styles.trendContainer} >
                    <span className={styles.trendIcon} >
                      {chargeback.trend == 'up' ? (
                        <TrendUp />
                      ) : (
                        <TrendDown />
                      )}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.emptyContainer} >
              <div className={styles.iconBox} >
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                  <path d="M13.1667 10C13.1667 9.66848 13.2984 9.35054 13.5329 9.11612C13.7673 8.8817 14.0852 8.75 14.4167 8.75H34.4167C34.7483 8.75 35.0662 8.8817 35.3006 9.11612C35.5351 9.35054 35.6667 9.66848 35.6667 10C35.6667 10.3315 35.5351 10.6495 35.3006 10.8839C35.0662 11.1183 34.7483 11.25 34.4167 11.25H14.4167C14.0852 11.25 13.7673 11.1183 13.5329 10.8839C13.2984 10.6495 13.1667 10.3315 13.1667 10ZM34.4167 18.75H14.4167C14.0852 18.75 13.7673 18.8817 13.5329 19.1161C13.2984 19.3505 13.1667 19.6685 13.1667 20C13.1667 20.3315 13.2984 20.6495 13.5329 20.8839C13.7673 21.1183 14.0852 21.25 14.4167 21.25H34.4167C34.7483 21.25 35.0662 21.1183 35.3006 20.8839C35.5351 20.6495 35.6667 20.3315 35.6667 20C35.6667 19.6685 35.5351 19.3505 35.3006 19.1161C35.0662 18.8817 34.7483 18.75 34.4167 18.75ZM34.4167 28.75H14.4167C14.0852 28.75 13.7673 28.8817 13.5329 29.1161C13.2984 29.3505 13.1667 29.6685 13.1667 30C13.1667 30.3315 13.2984 30.6495 13.5329 30.8839C13.7673 31.1183 14.0852 31.25 14.4167 31.25H34.4167C34.7483 31.25 35.0662 31.1183 35.3006 30.8839C35.5351 30.6495 35.6667 30.3315 35.6667 30C35.6667 29.6685 35.5351 29.3505 35.3006 29.1161C35.0662 28.8817 34.7483 28.75 34.4167 28.75ZM7.54175 8.125C7.17091 8.125 6.8084 8.23497 6.50005 8.44099C6.19171 8.64702 5.95139 8.93986 5.80947 9.28247C5.66756 9.62508 5.63043 10.0021 5.70278 10.3658C5.77512 10.7295 5.9537 11.0636 6.21592 11.3258C6.47815 11.588 6.81224 11.7666 7.17595 11.839C7.53967 11.9113 7.91667 11.8742 8.25928 11.7323C8.60189 11.5904 8.89473 11.35 9.10075 11.0417C9.30678 10.7334 9.41675 10.3708 9.41675 10C9.41675 9.50272 9.21921 9.02581 8.86757 8.67417C8.51594 8.32254 8.03903 8.125 7.54175 8.125ZM7.54175 18.125C7.17091 18.125 6.8084 18.235 6.50005 18.441C6.19171 18.647 5.95139 18.9399 5.80947 19.2825C5.66756 19.6251 5.63043 20.0021 5.70278 20.3658C5.77512 20.7295 5.9537 21.0636 6.21592 21.3258C6.47815 21.588 6.81224 21.7666 7.17595 21.839C7.53967 21.9113 7.91667 21.8742 8.25928 21.7323C8.60189 21.5904 8.89473 21.35 9.10075 21.0417C9.30678 20.7334 9.41675 20.3708 9.41675 20C9.41675 19.5027 9.21921 19.0258 8.86757 18.6742C8.51594 18.3225 8.03903 18.125 7.54175 18.125ZM7.54175 28.125C7.17091 28.125 6.8084 28.235 6.50005 28.441C6.19171 28.647 5.95139 28.9399 5.80947 29.2825C5.66756 29.6251 5.63043 30.0021 5.70278 30.3658C5.77512 30.7295 5.9537 31.0636 6.21592 31.3258C6.47815 31.588 6.81224 31.7666 7.17595 31.839C7.53967 31.9113 7.91667 31.8742 8.25928 31.7323C8.60189 31.5904 8.89473 31.35 9.10075 31.0417C9.30678 30.7334 9.41675 30.3708 9.41675 30C9.41675 29.5027 9.21921 29.0258 8.86757 28.6742C8.51594 28.3225 8.03903 28.125 7.54175 28.125Z" fill="#A4A3A8" />
                </svg>
              </div>

              <p className={styles.emptyTitle} >
                This card will display chargeback volume by merchant, highlighting those with abnormal or suspicious activity
              </p>
            </div>
          )}
        </>
      )}

    </div>
  )
}

export default Chargebacks;